import React from 'react'
import { Redirect, Route, useRouteMatch } from 'react-router-dom'

import EntryLayout from '../ui/layout/entryLayout'

const PublicRoutes = ({
  auth,
  component: Component,
  permit,
  validParams,
  param,
  disable,
  ...rest
}) => {

  return (
    <Route
      {...rest}
      render={props => (
        <EntryLayout>
          <Component {...props} />
        </EntryLayout>
      )}
    />
  )
}

export default PublicRoutes;
